import { Star } from "lucide-react";

export const Testimonials = ({ depoimentos, titulo = "O que nossos clientes dizem" }) => (
  <section className="my-12" data-testid="testimonials-section">
    <h2 className="font-heading font-black text-2xl md:text-3xl text-brand-dark uppercase tracking-tight mb-6">{titulo}</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {depoimentos.map((d, i) => (
        <article key={i} className="bg-white rounded-xl border border-gray-100 shadow-sm p-6" data-testid={`testimonial-${i}`}>
          <div className="flex items-center gap-1 mb-3" aria-label="5 estrelas">
            {[...Array(5)].map((_, s) => (
              <Star key={s} size={16} className="fill-brand-yellow text-brand-yellow" />
            ))}
          </div>
          <p className="text-gray-700 text-sm leading-relaxed mb-4">"{d.texto}"</p>
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-brand-red/10 text-brand-red font-heading font-bold flex items-center justify-center text-sm">
              {d.autor.charAt(0)}
            </div>
            <div>
              <p className="font-heading font-bold text-sm text-brand-dark">{d.autor}</p>
              <p className="text-xs text-gray-500">{d.servico}{d.bairro ? ` — ${d.bairro}` : ""}</p>
            </div>
          </div>
        </article>
      ))}
    </div>
  </section>
);
